export default __webpack_public_path__ + "static/media/time-to-care-today-tomorrow.82597aff.svg";